import { useController, useWatch } from 'react-hook-form';
import { SelectGroup, SelectGroupProps } from '@aqarmap/aqarmap-ui';
import useInputRules from '~/components/DesignSystem/Inputs/useInputRules';
import { RuleName } from '~/components/DesignSystem/Inputs/types';

type Props = SelectGroupProps & {
  control: any;
  ruleName?: RuleName;
  required?: boolean;
};

export default function SelectGroupController({
  list,
  control,
  required,
  ruleName,
  name = '',
  isMultiple,
  handleChange: handleSelectGroupChange,
  ...rest
}: Props) {
  const inputRules = useInputRules({ required, ruleName });

  const {
    field: { onChange: onControlChange },
    formState: { errors },
  } = useController({
    rules: inputRules,
    name,
    control,
    defaultValue: isMultiple ? [] : '',
  });

  const selected = useWatch({ control, name }) || (isMultiple ? [] : '');

  const updateListCheckedState = () => {
    return list.map((item) => ({
      ...item,
      field: {
        ...item.field,
        checked: isMultiple
          ? Array.isArray(selected) && selected.includes(item?.field?.value)
          : selected === item?.field?.value,
      },
    }));
  };

  return (
    <SelectGroup
      {...rest}
      list={updateListCheckedState()}
      error={errors[name]?.message?.toString()}
      handleChange={(e, value) => {
        onControlChange(value);
        if (handleSelectGroupChange) handleSelectGroupChange(e, value);
      }}
      isMultiple={isMultiple}
      name={name}
    />
  );
}
